import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts';
import { getSavedFilters, useChartVariables } from '../LineCharts';
import { Dayjs } from '../../lib';
import { formatAxisDateTimeToEchartsPattern, getDatetimeFormatByTimeDiff } from '../../utils';
import { useMemo } from 'react';
import { defaultGridConfig, toolboxAndTooltipConfig } from './configs/defaultGraphicOptions';
import { buildGraphicEvents } from './configs/defaultGraphicEvent';
import { getxAxisInterval } from './configs/calculateXAxisInterval';

interface SensorsGraphicProps {
  graphicOptions?: echarts.EChartsOption;
  isFlaring?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
}

export const SensorsGraphic = ({ graphicOptions, isFlaring, printRef }: SensorsGraphicProps) => {
  const { changeDateRange, chartId, dateRange } = useChartVariables();
  const handleZoom = (isZoomActive: boolean, start?: Dayjs, end?: Dayjs) => {
    const { period, dateRange } = getSavedFilters(chartId);

    return changeDateRange({
      isZoom: isZoomActive,
      period,
      dateRange: isZoomActive && start && end ? { start, end } : dateRange,
    });
  };

  const option = useMemo(() => {
    if (!graphicOptions || (graphicOptions && Object.keys(graphicOptions).length === 0)) return {};
    const gridSize =
      graphicOptions && Array.isArray(graphicOptions?.yAxis) ? graphicOptions?.yAxis.length : 0;
    const axisLabelFormat = formatAxisDateTimeToEchartsPattern(
      getDatetimeFormatByTimeDiff(dateRange.end.diff(dateRange.start, 'hour', false)),
    );

    const { zoomInterval } = getSavedFilters(chartId);

    const axisInterval = getxAxisInterval(
      Array.isArray(graphicOptions.series) ? graphicOptions.series : [],
    );

    return {
      ...toolboxAndTooltipConfig(!!zoomInterval, isFlaring, printRef),
      ...defaultGridConfig(gridSize, axisLabelFormat, axisInterval),
      ...graphicOptions,
    };
  }, [graphicOptions, dateRange]);

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      onEvents={buildGraphicEvents(handleZoom)}
      style={{ height: '100%', minHeight: '350px', width: '100%' }}
    />
  );
};
